import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import { SAlert } from '@avalara/skylab-sdk/react';
import { addReturnsOffer } from '../../lib/side-effects/offers';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { isFormIncomplete } from '../../lib/shared-signup';
import { selectState } from '../../selectors';
import ExternalLink from '../external-link';
import { purchaseDeflectionWording } from '../helpers';
const DisclaimerContainer = styled.div `
  padding-top: 20px;
`;
const BuyButtonAndDisclaimer = () => {
    const state = useSelector(selectState);
    const dispatch = useDispatch();
    const history = useHistory();
    const { account: { accountId, isAdmin, selectedPaymentMethod, isLoggedIn }, } = state;
    const onSubmit = () => {
        dispatch(updateProductAnalytics('buy_now'));
        if (accountId != null && selectedPaymentMethod != null) {
            dispatch(addReturnsOffer({
                history,
                paymentToken: selectedPaymentMethod.Id,
                successPage: '/returns/thank-you',
            }));
        }
    };
    const disabled = (isFormIncomplete(state.sharedSignup) && state.account.accountId === null)
        || (isLoggedIn && isAdmin === false);
    return (React.createElement(DisclaimerContainer, null,
        (selectedPaymentMethod) && React.createElement("button", { id: 'submit-payment', "data-ref": 'buy.returns-disclaimer.submit-button', className: 'primary', disabled: disabled, onClick: disabled ? undefined : onSubmit }, "Buy now"),
        (isLoggedIn && isAdmin === false)
            ? React.createElement(SAlert, { className: 'margin-top-sm', status: 'warning', noDismiss: true },
                React.createElement("div", { "data-ref": 'buy.returns-disclaimer.purchase-deflection' }, purchaseDeflectionWording))
            : React.createElement(Fragment, null,
                React.createElement("p", { className: 'pad-top-sm' },
                    'By clicking ',
                    React.createElement("span", { className: 'font-bold' }, !selectedPaymentMethod ? 'Finish' : 'Buy now'),
                    ' you are purchasing a recurring, 12-month subscription, and you accept the ',
                    React.createElement(ExternalLink, { "data-ref": 'buy.returns-disclaimer.terms-conditions.link', href: TERMS_LINKS.general, alwaysOpenInNewTab: true }, 'Avalara Service Terms and Conditions.')),
                React.createElement("div", null,
                    React.createElement("p", { "data-ref": 'buy.returns-disclaimer.payment-text', className: 'pad-top-sm' },
                        "Your payment method will be used for automatic payment of all invoices. You must cancel on or before the expiration date of the then-current subscription term to avoid additional charges. Information on how to cancel is available here: ",
                        React.createElement("a", { href: 'https://knowledge.avalara.com/cancellation', target: '_blank', rel: 'noopener noreferrer' }, "https://knowledge.avalara.com/cancellation"),
                        "."),
                    React.createElement("p", { "data-ref": 'buy.returns-disclaimer.authorization-text', className: 'pad-top-sm' }, "You're authorizing us to process payment using your payment method. We will automatically charge your payment method on the invoice due date. You can update your payment method at any time.")))));
};
export default BuyButtonAndDisclaimer;
